// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","logoSvg":"Logo_logoSvg__YJ88A"};